module.exports = __webpack_public_path__ + "static/img/bchsb.af4a06b4.png";